export default [
  {
    label: '现金',
    value: '现金'
  },
  {
    label: '银行转账',
    value: '银行转账'
  },
  {
    label: '支票',
    value: '支票'
  }
]



// WEBPACK FOOTER //
// ./src/utils/payChannelOptions.js